var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentStep===1)?_c('Step1'):_vm._e(),(_vm.currentStep===2)?_c('Step2'):_vm._e(),(_vm.currentStep===3)?_c('Step3'):_vm._e(),(_vm.currentStep===4)?_c('Failed'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }